import { checkNotNull } from "./utilFunctions"

export const ENVIRONMENT_CALCULATED = checkNotNull(process.env.NODE_ENV === 'development' ? 'dev' : process.env.NODE_ENV === 'production' ? 'prod' : null, 'Tya7YYnNQ211')
